import APIService from "./APIService";

class TellerService extends APIService {
  search = async (search: string = "", page: number = 1, limit: number = 10, sort: string) => {
    const result = await this.get(
      "tellers/search?generic=" + search + "&page=" + page + "&limit=" + limit + "&sort=" + sort
    );
    return result ? result.data : null;
  };

  add = async (
    first_name: string,
    last_name: string,
    email: string,
    contact_no: string,
    branches: string[]
  ) => {
    const result = await this.post(
      { first_name, last_name, email, contact_no, branches },
      "tellers"
    );
    return result ? result.data : null;
  };

  edit = async (
    first_name: string,
    last_name: string,
    email: string,
    contact_no: string,
    id: string,
    branches: string[]
  ) => {
    const result = await this.put(
      { first_name, last_name, email, contact_no, branches },
      "tellers/" + id
    );
    return result ? result.data : null;
  };

  delete = async (id: string) => {
    const result = await this.remove("tellers/" + id);
    return result ? result.data : null;
  };

  getBranch = async () => {
    const result = await this.get("/markets/branch");
    return result ? result.data : null;
  };
}
export default TellerService;
